// Fix the confict suggestion search in Debut theme
if (typeof theme !== "undefined" && theme.hasOwnProperty("settings"))
  theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSConfig.custom.products_per_page,
    loadProductFirst: true,
    numberFilterTree: 2,
    filterTreeMobileStyle: "style2",
  },
};

(function () {
  var onSale = false,
    soldOut = false,
    bogo = false,
    priceVaries = false,
    hidden_product = false,
    customer_login = false,
    customer_has_discount = false,
    customer_class = "customer-login",
    customer_discount_class = "customer-has-discount",
    bodyclass = $("body").attr("class");
  (images = []), (boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066]);

  BoostPFS.inject(this);

  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    if (bodyclass.indexOf(customer_class) != -1) {
      customer_login = true;
    }
    if (bodyclass.indexOf(customer_discount_class) != -1) {
      customer_has_discount = true;
    }

    var tags = data.tags;
    if (tags.indexOf("badge-bogo") != -1) {
      bogo = true;
    } else {
      bogo = false;
    }

    if (tags.indexOf("afc_price_hidden_on") != -1 || tags.indexOf("delivery_status_3") != -1) {
      price_hidden_tag = true;
    } else {
      price_hidden_tag = false;
    }

    if (tags.indexOf("pimType_event") != -1) {
      hidden_product = true;
    } else {
      hidden_product = false;
    }

    // console.log(data);
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    hidden_product = data.product_type == "HIDDEN_PRODUCT";

    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    if (
      typeof aico_hide_for_non_logged_in_users !== "undefined" &&
      aico_hide_for_non_logged_in_users.length &&
      aico_hide_for_non_logged_in_users.includes(
        'a[href="/products/' + data.handle + '"]'
      )
    ) {
      // if(aico_hide_for_non_logged_in_users.includes('a[href="/products/'+data.handle+'"]')){
      var itemHtml = "";
      return itemHtml;
      //}
    } else {
      // Customize API data to get the Shopify data
      data = prepareShopifyData(data);

      // Get Template
      var itemHtml = boostPFSTemplate.productGridItemHtml;
      // Add Custom class
      var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : "";
      var saleClass = onSale ? boostPFSTemplate.saleClass : "";
      var hiddenClass = hidden_product ? "hidden_true" : "hidden_false";

      itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

      itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

      itemHtml = itemHtml.replace(/{{hiddenClass}}/g, hiddenClass);

      // Add Card product class
      itemHtml = itemHtml.replace(
        /{{cardProductClass}}/g,
        buildCardProductClass()
      );
      // Add sold out Label
      itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
      // Add sale Label
      itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
      // Add Bogo Label
      itemHtml = itemHtml.replace(/{{itemBogo}}/g, buildBogoLabel());
      // Add Images
      itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
      // Add Price
      itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

      // Add Review
      if (
        typeof Integration === "undefined" ||
        (typeof Integration != "undefined" &&
          typeof Integration.hascompileTemplate == "function" &&
          !Integration.hascompileTemplate("reviews"))
      ) {
        itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
      }

      // Add Vendor
      itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

      // Add main attribute (Always put at the end of this function)

      //console.log(data);
      var data_title = Utils.getProductMetafield(
        data,
        "custom_fields",
        "price_hidden"
      );

      var current_language = $("input#LocaleSelector").val();

      var data_title = data.title;
      if (current_language == "de") {
        data_title = data.title;
      } else if (current_language == "fr") {
        var title_fr = Utils.getProductMetafield(
          data,
          "custom_fields",
          "title_fr"
        );
        if (title_fr == "<br>") {
          data_title = data.title;
        } else {
          data_title = title_fr;
        }
      } else if (current_language == "it") {
        var title_it = Utils.getProductMetafield(
          data,
          "custom_fields",
          "title_it"
        );
        if (title_it == "<br>") {
          data_title = data.title;
        } else {
          data_title = title_it;
        }
      }

      itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
      itemHtml = itemHtml.replace(/{{itemTitle}}/g, data_title);
      itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
      itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
      itemHtml = itemHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildProductItemUrl(data)
      );
      var handle = data.handle;
      if (
        handle.indexOf("workshop") > -1 ||
        handle.indexOf("fully-booked") > -1 ||
        handle.indexOf("symposium") > -1
      ) {
        itemHtml = itemHtml.replace(/{{itemstyle}}/g, "display:none");
      }
      //console.log('itemHtml',itemHtml);
      return itemHtml;
    }
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildImages(data) {
    var html = "",
      aspectRatio = "",
      rangeWidths = boostPFSRangeWidths,
      paddingBottom = 100;

    var dataSrcSet = "",
      imgAlt = data.title,
      flipImageSrcSet = "";

    var activeSwapImage =
      !Utils.isMobile() &&
      images.length > 1 &&
      boostPFSThemeConfig.custom.hasOwnProperty("show_secondary_image") &&
      boostPFSThemeConfig.custom.show_secondary_image == true;

    for (var i = 0; i < rangeWidths.length; i++) {
      dataSrcSet +=
        Utils.getFeaturedImage(images, rangeWidths[i] + "x") +
        " " +
        rangeWidths[i] +
        "w";

      if (activeSwapImage) {
        flipImageSrcSet +=
          Utils.optimizeImage(images[1]["src"], rangeWidths[i] + "x") +
          " " +
          rangeWidths[i] +
          "w";
      }

      if (i < rangeWidths.length - 1) {
        dataSrcSet += ", ";

        if (activeSwapImage) {
          flipImageSrcSet += ", ";
        }
      }
    }

    if (images.length > 0) {
      aspectRatio = images[0]["width"] / images[0]["height"];
      paddingBottom = (1 / aspectRatio) * 100;

      html += "<div";
      if (
        boostPFSThemeConfig.custom.hasOwnProperty("add_image_padding") &&
        boostPFSThemeConfig.custom.add_image_padding === true
      ) {
        html += ' class="card__media-full-spacer"';
      }
      html += ">";
      html += '<div class="media media--transparent media--';
      if (boostPFSThemeConfig.custom.hasOwnProperty("media_size")) {
        html += boostPFSThemeConfig.custom.media_size;
      }
      html += ' media--hover-effect"';
      if (
        boostPFSThemeConfig.custom.hasOwnProperty("media_size") &&
        boostPFSThemeConfig.custom.media_size == "adapt" &&
        images.length > 0
      ) {
        html += ' style="padding-bottom: ' + paddingBottom + '%"';
      }
      html += ">";
      html +=
        '<img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="' +
        dataSrcSet +
        '" ' +
        'height="' +
        images[0].height +
        '" ' +
        'width="' +
        images[0].width +
        '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
        'src="' +
        Utils.optimizeImage(images[0].src, "533x") +
        '" ' +
        'alt="' +
        imgAlt +
        '" />';

      if (activeSwapImage) {
        html +=
          '<img class="motion-reduce"' +
          'loading="lazy"' +
          'srcset="' +
          flipImageSrcSet +
          '" ' +
          'height="' +
          images[1].height +
          '" ' +
          'width="' +
          images[1].width +
          '" ' +
          'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
          'src="' +
          Utils.optimizeImage(images[1].src, "533x") +
          '" ' +
          'alt="' +
          imgAlt +
          '" />';
      }
      html += "</div>";
      html += "</div>";
    } else {
      //       html += '<div class="card__content"><h2 class="card__text h2">' + data.title  + '</h2></div>'
      html += "<div";
      if (
        boostPFSThemeConfig.custom.hasOwnProperty("add_image_padding") &&
        boostPFSThemeConfig.custom.add_image_padding === true
      ) {
        html += ' class="card__media-full-spacer"';
      }
      html += ">";
      html += '<div class="media media--transparent media--';
      if (boostPFSThemeConfig.custom.hasOwnProperty("media_size")) {
        html += boostPFSThemeConfig.custom.media_size;
      }
      html += ' media--hover-effect"';
      if (
        boostPFSThemeConfig.custom.hasOwnProperty("media_size") &&
        boostPFSThemeConfig.custom.media_size == "adapt" &&
        images.length > 0
      ) {
        html += ' style="padding-bottom: ' + paddingBottom + '%"';
      }
      html += ">";
      let productImage = '';
      let productMetafields = data.metafields;
      for(let a=0; a<productMetafields.length; a++){
        let productMetafield = productMetafields[a];
        if(productMetafield.key == "image_de_ch"){
          productImage = productMetafield.value;
        }
      }
      if(productImage == ''){
        productImage = 'https://cdn.shopify.com/s/files/1/0607/2906/5691/files/no-image.gif?v=1653645242';
      }
      html +=
        '<img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="'+productImage+'" ' +
        'height="476" ' +
        'width="600" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
        'src="'+productImage+'" ' +
        'alt="' +
        imgAlt +
        '" />';

      html += "</div>";
      html += "</div>";
    }
    return html;
  }

  function buildCardProductClass() {
    var html = "";
    if (!images || (images && images.length === 0)) {
      html = "card--text-only card--soft";
    } else if (
      boostPFSThemeConfig.custom.hasOwnProperty("show_image_outline") &&
      boostPFSThemeConfig.custom.show_image_outline
    ) {
      html = "card--outline";
    }
    return html;
  }

  function buildVendor(data) {
    var html = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("show_vendor") &&
      boostPFSThemeConfig.custom.show_vendor === true
    ) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

  function buildPrice(data) {
    var aico_product_price_hide = "false";
    data.tags.forEach(function (v, k) {
      if (typeof aico.aico_hidden_price_for_all !== "undefined") {
        if (v != "" && aico.aico_hidden_price_for_all.includes(v.trim())) {
          aico_product_price_hide = "true";
        }
      }
    });
    if (customer_login == false) {
      data.tags.forEach(function (v, k) {
        if (typeof aico.aico_hidden_price_for_nonlogin !== "undefined") {
          if (
            v != "" &&
            aico.aico_hidden_price_for_nonlogin.includes(v.trim())
          ) {
            aico_product_price_hide = "true";
          }
        }
      });
    }

    var isDiscountedProduct = false;
    if (data.vendor == "Celluma" || data.vendor == "Dermapenworld") {
      isDiscountedProduct = true;
    }

    var html = "";
    var noComparePrice =
      data.price_varies === false && data.compare_at_price_varies;
    var priceAmount = boostPFSConfig.custom.currency_code_enabled
      ? Utils.formatMoney(data.price_min, "money_with_currency")
      : Utils.formatMoney(data.price_min);
    var compareAtPrice = boostPFSConfig.custom.currency_code_enabled
      ? Utils.formatMoney(data.compare_at_price_min, "money_with_currency")
      : Utils.formatMoney(data.compare_at_price_min);

    // start aico calculate price list and discount group
    var moneyPrice = "";
    var OrgMoneyPrice = "";
    var discountPrice = "";
    var ab_contain = false;
    //console.log('priceAmount',priceAmount);
    moneyPrice = priceVaries
      ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount)
      : priceAmount;
    var originalMoneyPrice = moneyPrice;
    //console.log("originalMoneyPrice", originalMoneyPrice);
    //console.log('data',data);
    if (moneyPrice.includes("ab")) {
      ab_contain = true;
    }
    //console.log("starting price", moneyPrice);
    if (
      typeof aico.aico_price_list_customer !== "undefined" ||
      typeof aico.aico_discount_list_customer !== "undefined"
    ) {
      if (aico.aico_price_list_customer || aico.aico_discount_list_customer) {
        if (
          typeof collection_product_with_final_price !== "undefined" &&
          Object.values(collection_product_with_final_price).length &&
          data.handle in collection_product_with_final_price
        ) {
          var key = data.handle;
          if (collection_product_with_final_price[key]) {
            moneyPrice = collection_product_with_final_price[key];
            moneyPrice = moneyPrice.toString().replace("CHF", "");
            moneyPrice = moneyPrice.toString().replace("CHF", "");
            if (ab_contain) {
              moneyPrice = "ab CHF " + moneyPrice;
            } else {
              moneyPrice = "CHF " + moneyPrice;
            }
          }
          //console.log("moneyPrice 2", moneyPrice);
          //moneyPrice = "CHF " + moneyPrice;
          //console.log("exist", data.handle);
        } else {
          //console.log("not exist", data.handle);
          if (
            aico.aico_price_list_customer ||
            aico.aico_discount_list_customer
          ) {
            var product_metafield = "";
            product_metafield = "false";
            data.metafields.forEach(function (v, k) {
              if (v.key == "price_list_data") {
                product_metafield = "true";
              }
            });
            if (
              product_metafield != "false" ||
              aico.aico_login_customer_discount_metafield != ""
            ) {
              let aico_price_object = {};
              data.metafields.forEach(function (v, k) {
                var product_discount_price = "";
                if (v.key == "price_list_data") {
                  aico_price_object.price_list_data = JSON.parse(v.value);
                }
              });
              aico_price_object.vendor = data.vendor;
              var aico_product_collections = [];
              var collections = data.collections;
              collections.forEach(function (v, k) {
                aico_product_collections.push(v.title);
              });
              var aico_product_collections_string =
                aico_product_collections.toString();
              aico_price_object.aico_product_collections =
                aico_product_collections_string;
              aico_price_object.price = data.price_min.toString();
              if(data.compare_at_price_min != null){
                aico_price_object.compare_price = data.compare_at_price_min.toString();
              } else {
                aico_price_object.compare_price = '';
              }
              // console.log("aico_price_object.price", aico_price_object.price);
              var product_handle = data.handle;
              
              aico.aico_price_list_products.push({
                [product_handle]: aico_price_object,
              });

              aico.aico_price_list_products.forEach(function (v, k) {
                var object_product_handle = Object.keys(v)[0];
                if (object_product_handle == product_handle) {
                  aicoPrice = aico_get_price_list_price(v);
                  let aicoComparePrice = aicoPrice.compare_price;
                  if(aicoComparePrice != 0) {
                    //alert(aicoComparePrice);
                    compareAtPrice = Utils.formatMoney(aicoComparePrice, "money_with_currency");
                  }
                  aicoPrice = aicoPrice.price_list_price;

                  if (aicoPrice > 0) {
                    if (data.price_min != aicoPrice) {
                      isDiscountedProduct = true;
                      customer_has_discount = true;
                    }
                    moneyPrice = aicoPrice;
                    OrgMoneyPrice = data.price_min;
                    moneyPrice = moneyPrice.toString().replace("CHF", "");
                    discountPrice = aicoPrice;
                    

                    if (ab_contain) {
                      let price_formatted = parseFloat(
                        moneyPrice
                      ).toLocaleString(
                        window.Shopify.locale + "-CH",
                        { style: "currency", currency: Shopify.currency.active }
                      );
                      moneyPrice = "ab " + price_formatted;
                    } else {
                      let price_formatted = parseFloat(
                        moneyPrice
                      ).toLocaleString(
                        window.Shopify.locale + "-CH",
                        { style: "currency", currency: Shopify.currency.active }
                      );

                      moneyPrice = price_formatted;
                    }
                  }
                }
              });
            }
          }
        }
      } else {
        var moneyPrice = priceVaries
          ? boostPFSConfig.label.from_price_html.replace(
              /{{ price }}/,
              priceAmount
            )
          : priceAmount;
      }
    } else {
      var moneyPrice = priceVaries
        ? boostPFSConfig.label.from_price_html.replace(
            /{{ price }}/,
            priceAmount
          )
        : priceAmount;
    }
    var price_hidden = Utils.getProductMetafield(
      data,
      "custom_fields",
      "price_hidden"
    );
    var unitPriceClass =
      !data.available ||
      typeof data?.selected_or_first_available_variant
        ?.unit_price_measurement === "undefined"
        ? "hidden"
        : "";
      if(customer_login == true){
        if(typeof aicoPrice != 'undefined') {
            if(aicoPrice == 0){
              isDiscountedProduct = false;
            } 
          }
      }

    html = `<div class="customer-${customer_login} customer-has-discount-${customer_has_discount} vendor-${
      data.vendor
    } price price-${price_hidden} price-${data.price_min} ${
      soldOut ? "price--sold-out" : ""
    } ${onSale ? "price--on-sale" : ""}${
      noComparePrice ? "price--no-compare" : ""
    }">
<div class="price-wrapper" ${
      price_hidden_tag == true ? 'style="display:none"' : "no"
    }>
<div class="price__regular">

<s class="price-item price-item--original" ${
      isDiscountedProduct == true &&
      customer_login == true &&
      customer_has_discount == true
        ? ""
        : 'style="display:none"'
    }>
${
  aico_product_price_hide == false && customer_login == false
    ? ""
    : price_hidden == "true"
    ? ""
    : originalMoneyPrice
}
</s>

<span class="visually-hidden visually-hidden--inline">
${boostPFSConfig.label.regular_price}
</span>
<span class="price-item price-item--regular money" data-product-id="${data.id}"
${discountPrice != OrgMoneyPrice ? "style=color:red;" : "style=color:black;"} >
${
  aico_product_price_hide == false && customer_login == false
    ? ""
    : price_hidden == "true"
    ? "Preis auf Anfrage"
    : moneyPrice
}
</span>



</div>
<div class="price__sale 2">
<span>
<s class="price-item price-item--regular" style="padding-left:0px; font-size:16px;">
${customer_login == false ? "" : price_hidden == "true" ? "" : compareAtPrice}
</s>
</span>
<span class="visually-hidden visually-hidden--inline">
${boostPFSConfig.label.regular_price}
</span>
<span class="price-item price-item--last"
${data.price_min != data.compare_at_price_min ? "style=color:red;" : "style=color:black"}
>
${
  customer_login == false
    ? ""
    : price_hidden == "true"
    ? "Preis auf Anfrage"
    : moneyPrice
}
</span>
<span class="visually-hidden visually-hidden--inline">${
      boostPFSConfig.label.sale_price
    }</span>

</div>
<small class="unit-price caption ${unitPriceClass}">
<span class="visually-hidden">${boostPFSConfig.label.unit_price}</span>
<span class="price-item price-item--last">
<span>${Utils.formatMoney(
      data.selected_or_first_available_variant &&
        data.selected_or_first_available_variant.unit_price
    )}</span>
<span aria-hidden="true">/</span>
<span class="visually-hidden">&nbsp;${
      boostPFSConfig.label.unit_price_separator
    }&nbsp;</span>
</span>
</small>
</div>
</div>`;
    return html;
  }

  function buildSoldOutLabel() {
    // Build Sold out label
    var soldOutLabel = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty(
        "sold_out_badge_color_scheme"
      ) &&
      soldOut
    ) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(
        /{{soldOutBadgeClass}}/g,
        boostPFSThemeConfig.custom.sold_out_badge_color_scheme
      );
    }
    return soldOutLabel;
  }

  function buildSaleLabel() {
    // Build Sale label    
    var saleLabel = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("sale_badge_color_scheme") &&
      onSale ) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(
        /{{saleBadgeClass}}/g,
        boostPFSThemeConfig.custom.sale_badge_color_scheme
      );
    }    
    return saleLabel;
  }

  function buildBogoLabel() {
    // Build Bogo label
    var bogoLabel = "";
    if (bogo == true) {
      bogoLabel = boostPFSTemplate.bogoLabelHtml;
    }
    return bogoLabel;
  }

  function buildReview(data) {
    var html = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("show_product_review") &&
      boostPFSThemeConfig.custom.show_product_review == true &&
      Utils.getProductMetafield(data, "reviews", "rating") !== null
    ) {
      var ratingObj = JSON.parse(
        Utils.getProductMetafield(data, "reviews", "rating")
      );
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >= 0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info
        .replace("{{ rating_value }}", ratingObj.value)
        .replace("{{ rating_max }}", ratingObj.value.scale_max)}">
<span aria-hidden="true" class="rating-star color-icon-${
        boostPFSConfig.custom.accent_icons
      }" style="--rating: ${Math.round(
        ratingObj.value.rating
      )}; --rating-max: ${
        ratingObj.value.scale_max
      }; --rating-decimal: ${rating_decimal};"></span>
</div>
<p class="rating-text caption">
<span aria-hidden="true">${ratingObj.value} / ${
        ratingObj.value.scale_max
      }</span>
</p>
<p class="rating-count caption">
<span aria-hidden="true">(${Utils.getProductMetafield(
        data,
        "reviews",
        "rating_count"
      )})</span>
<span class="visually-hidden">${Utils.getProductMetafield(
        data,
        "reviews",
        "rating_count"
      )} ${boostPFSConfig.label.total_reviews}</span>
</p>`;
    }
    return html;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return "";
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml =
      currentPage > 1 ? boostPFSTemplate.previousActiveHtml : "";
    previousHtml = previousHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage - 1)
    );
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml =
      currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : "";
    nextHtml = nextHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage + 1)
    );
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (
      var iBefore = currentPage - 1;
      iBefore > currentPage - 3 && iBefore > 0;
      iBefore--
    ) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift("...");
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (
      var iAfter = currentPage + 1;
      iAfter < currentPage + 3 && iAfter <= totalPage;
      iAfter++
    ) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push("...");
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = "";
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == "...") {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml +=
          pageArr[iPage] == currentPage
            ? boostPFSTemplate.pageItemSelectedHtml
            : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
      );
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || "";
        // Build content
        var sortingItemsHtml = "";
        for (var k in sortingArr) {
          var isSelected = "";
          if (paramSort == k) {
            isSelected = 'selected="selected"';
          }
          sortingItemsHtml +=
            '<option value="' +
            k +
            '"' +
            isSelected +
            ">" +
            sortingArr[k] +
            "</option>";
        }
        html = boostPFSTemplate.sortingHtml.replace(
          /{{sortingItems}}/g,
          sortingItemsHtml
        );
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (
      jQ(".boost-pfs-filter-custom-sorting").hasClass(
        "boost-pfs-filter-sort-active"
      )
    ) {
      jQ(".boost-pfs-filter-custom-sorting").toggleClass(
        "boost-pfs-filter-sort-active"
      );
    }

    var labelSort = "";
    var paramSort = Globals.queryParams.sort || "";
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting_heading;
    }

    jQ(".boost-pfs-filter-custom-sorting button span span").text(labelSort);
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    jQ(Selector.topSorting + " .facet-filters__sort").change(function (e) {
      e.preventDefault();
      FilterApi.setParam("sort", jQ(this).val());
      FilterApi.setParam("page", 1);
      FilterApi.applyFilter("sort");
    });
  };

  // Add additional feature for product list, used commonly in customizing product list
  // ProductList.prototype.afterRender = function (data) {
  //   if (!data) data = this.data;

  //   // Integrate with Bold Custom Price
  //   var boldJSData = JSON.parse(jQ("#bold-platform-data").text());
  //   // Fix price if product do not have bold value
  //   for (var i = 0; i < data.length; i++) {
  //     data[i].price_min = data[i].price_min * 100;
  //     data[i].price_max = data[i].price_max * 100;
  //     data[i].compare_at_price_min = data[i].compare_at_price_min * 100;
  //     data[i].compare_at_price_max = data.compare_at_price_max * 100;
  //     var boldVariants = data[i].variants;
  //     for (var j = 0; j < boldVariants.length; j++) {
  //       boldVariants[j].price = boldVariants[j].price * 100;
  //       boldVariants[j].compare_at_price =
  //         boldVariants[j].compare_at_price * 100;
  //     }
  //   }
  //   boldJSData.collection = data;
  //   jQ("#bold-platform-data").text(JSON.stringify(boldJSData));
  //   reload_js("https://static.boldcommerce.com/bold-platform/sf/pr.js");
  //   // End integrate Bold
  // };

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };

  // Build Additional Elements
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    jQ(".boost-pfs-filter-total-product").html(
      data.total_product + " Produkte"
    );
    $(".wrapperDiv").remove();
    var lang = $("html").attr("lang");
    var curr_lang = $("input#LocaleSelector").val();

    if (curr_lang == "fr") {
      var loginMsg =
        'Pour voir les prix, vous devez vous <a href="/account/login">inscrire/connecter</a>.';
    } else if (curr_lang == "it") {
      var loginMsg =
        'Per vedere i prezzi è necessario registrarsi o effettuare il <a href="/account/login">login</a>.';
    } else {
      var loginMsg =
        'Um die Preise zu sehen, müssen Sie sich <a href="/account/login">registrieren/einloggen</a>.';
    }
    var loginNotice =
      '<span class="price-item price-item-hover price-item--regular">' +
      loginMsg +
      "</span>";

    if (bodyclass.indexOf(customer_class) != -1) {
      customer_login = true;
    }
    if (customer_login == false) {
      $(".login_notice").html(loginNotice);
      // console.log('customer not login');
    }

    setTimeout(function () {
      for (var i = 1; i <= 5; i++) {
        var n = 6;
        $(
          ".boost-pfs-filter-option-attributes ul.boost-pfs-filter-option-item-list-single-list li.boost-pfs-filter-option-item, .boost-pfs-filter-option-list .boost-pfs-filter-option-item-list-single-list li.boost-pfs-filter-option-item"
        ).each(function (e) {
          var name = $(this).find(".boost-pfs-filter-option-value").text();
          var thats = $(this);
          var filter_title = $(this)
            .parents(".boost-pfs-filter-option-list")
            .find(
              ".boost-pfs-filter-option-title-text:not(.boost-pfs-filter-option-title-count)"
            )
            .text();

          var filter_title_new = filter_title.replace(1, "");
          filter_title_new = filter_title_new.replace(2, "");

          if (name.indexOf("-") > -1) {
            //               thats.parents('.mainwrapperDiv').hide();
          } else {
            var data_index = name + "-" + (n - i);
          }

          $(this).after(
            '<div class="star" data-index="attribute_' +
              lang +
              "_" +
              filter_title_new +
              "_" +
              data_index +
              '"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 55.867 55.867" style="enable-background:new 0 0 55.867 55.867;" xml:space="preserve"><path d="M55.818,21.578c-0.118-0.362-0.431-0.626-0.808-0.681L36.92,18.268L28.83,1.876c-0.168-0.342-0.516-0.558-0.896-0.558 s-0.729,0.216-0.896,0.558l-8.091,16.393l-18.09,2.629c-0.377,0.055-0.689,0.318-0.808,0.681c-0.117,0.361-0.02,0.759,0.253,1.024 l13.091,12.76l-3.091,18.018c-0.064,0.375,0.09,0.754,0.397,0.978c0.309,0.226,0.718,0.255,1.053,0.076l16.182-8.506l16.18,8.506 c0.146,0.077,0.307,0.115,0.466,0.115c0.207,0,0.413-0.064,0.588-0.191c0.308-0.224,0.462-0.603,0.397-0.978l-3.09-18.017 l13.091-12.761C55.838,22.336,55.936,21.939,55.818,21.578z"/></svg></div>'
          );
        });
      }
      $(".star").click(function (e) {
        $(".star").css("pointer-events", "none");
        var index = $(this).attr("data-index");
        //index = index.toLowerCase().replace(/ /g,'-');
        $(this).addClass("active");
        $(this).nextAll().removeClass("active");
        $(this).prevAll().addClass("active");

        var locations = location.pathname;
        var locations_all = location.href;
        var location_search = location.search.split("=");
        var nacken = getUrlParameter("pf_t_gesicht_nacken");

        var filter_param = $(this)
          .parents(".boost-pfs-filter-option-list")
          .find(".boost-pfs-filter-option-content")
          .attr("id");
        var filter_param_ori = filter_param.replace(
          "boost-pfs-filter-tree-",
          ""
        );
        var filter_param_new = filter_param.replace(
          "boost-pfs-filter-tree-",
          ""
        );
        var spaceCount = filter_param_new.split("-").length - 1;

        for (var i = 0; i < spaceCount; i++) {
          filter_param_new = filter_param_new.replace("-", "_");
        }

        var url = new window.URL(document.location); // fx. http://host.com/endpoint?abc=123

        if (window.location.href.indexOf(filter_param_new) > -1) {
          url.searchParams.set(filter_param_new, index);

          var index_count = index.slice(-1);
          var index_original_count = index_count;

          if (index_count < 5) {
            while (index_count <= 5) {
              if (index_original_count != index_count) {
                url.searchParams.append(
                  filter_param_new,
                  index.slice(0, -1) + index_count
                );
              }
              index_count++;
            }
          }

          var new_url = url.toString();

          window.location = new_url;

          /*$.ajax({
              url: new_url,
              type: 'GET',
              success: function(res) {

                setTimeout(function(){
                  $('#main-collection-product-grid').html('');
                  $('#main-collection-product-grid').html($(res).find("#main-collection-product-grid").html());
                },500);
                setTimeout(function(){

                  $('.star').css("pointer-events", "auto");
                }, 1000);
              }

            });*/
        } else {
          $.ajax({
            url: "https://lasermedch.myshopify.com" + locations + "/" + index,
            type: "GET",
            success: function (res) {
              setTimeout(function () {
                $("#main-collection-product-grid").html("");
                $("#main-collection-product-grid").html(
                  $(res).find("#main-collection-product-grid").html()
                );
              }, 500);
              setTimeout(function () {
                $(".star").css("pointer-events", "auto");
              }, 1000);
            },
          });
        }
      });

      $(".boost-pfs-filter-option-label").click(function () {
        $(".wrapperDiv").hide();
        $(this).find(".wrapperDiv").show();
      });
      //     $('.boost-pfs-filter-option-item.boost-pfs-filter-option-label').each(function(){})
      if (
        $(
          ".boost-pfs-filter-option-item.boost-pfs-filter-option-label"
        ).hasClass("selected")
      ) {
        $(
          ".boost-pfs-filter-option-item.boost-pfs-filter-option-label.selected"
        )
          .parents(".mainwrapperDiv")
          .find(".wrapperDiv")
          .show();
        var option_value = $(
          ".boost-pfs-filter-option-item.boost-pfs-filter-option-label.selected"
        )
          .find(".boost-pfs-filter-option-value")
          .text();
        //         console.log(option_value);
      } else {
        $(".wrapperDiv").hide();
      }

      $(".boost-pfs-filter-option-item  + .star").each(function () {
        $(this)
          .nextUntil(".boost-pfs-filter-option-item")
          .addBack()
          .wrapAll("<div class='wrapperDiv' />");
      });
      $(".boost-pfs-filter-option-item").each(function () {
        $(this)
          .nextUntil(".boost-pfs-filter-option-item")
          .addBack()
          .wrapAll("<div class='mainwrapperDiv' />");
      });

      $(".boost-pfs-filter-option-value").each(function () {
        var val = $(this).text();        
        
        var $this = $(this);
        if (val.indexOf("-") > -1) {          
          if(val != 'ELLA-CS, S.r.o.') {
            $this.parents(".mainwrapperDiv").hide();
          }
        }
      });
    });
    $(document).on("click", ".removeOtherStarFilters", function (e) {
      e.preventDefault();
      $(".boost-pfs-filter-clear-all").trigger("click");
    });
    function showSelectedRateDiv() {
      var star_marked = false;
      $(".boost-pfs-filter-refine-by-items .refine-by-item").each(function (
        i,
        li
      ) {
        var product = $(this);
        var selected_option = product.find(".refine-by-option").text();
        var selected_option_new = selected_option.replace(":", "");
        selected_option_new = selected_option_new.trim();
        var selected_value = product.find(".refine-by-value").text();
        var selected_array = selected_value.split("-");

        if (selected_array.length > 1) {
          var list_opt = $(
            ".boost-pfs-filter-option-list .boost-pfs-filter-option-item-list-single-list .boost-pfs-filter-option-title-text"
          ).text();

          $(document)
            .find(
              ".boost-pfs-filter-options-wrapper .boost-pfs-filter-option-list"
            )
            .each(function (i, li) {
              var t = $(this);
              var list_opt = t
                .find(".boost-pfs-filter-option-title-text")
                .text();
              var list_opt_new = list_opt.replace(
                t.find(".boost-pfs-filter-option-title-count").text(),
                ""
              );
              let result = selected_option_new.localeCompare(list_opt_new);

              if (result == 0) {
                t.find(".mainwrapperDiv").each(function (i, v) {
                  var list = $(this);
                  var list_opt_val = list
                    .find(".boost-pfs-filter-option-value")
                    .text();
                  let result_val = selected_array[0]
                    .replace(/\s/g, "")
                    .localeCompare(list_opt_val.replace(/\s/g, ""));

                  if (result_val == 0) {
                    list
                      .find(".boost-pfs-filter-option-label")
                      .addClass("selected");
                    list
                      .find(".boost-pfs-filter-button")
                      .attr("aria-checked", "true");

                    if (star_marked === false) {
                      let button_class =
                        selected_array[0] + "-" + selected_array[1];

                      $(".refine-by-value:contains(" + button_class + ")")
                        .parents("button.boost-pfs-filter-clear")
                        .addClass("removeOtherStarFilters");
                      list.find(".wrapperDiv .star").each(function (index) {
                        if (index < selected_array[1]) {
                          var startlist = $(this);
                          startlist.addClass("active");
                        }
                      });
                      star_marked = true;
                    } else {
                      let button_class =
                        selected_array[0] + "-" + selected_array[1];
                      $(".refine-by-value:contains(" + button_class + ")")
                        .parents("div.refine-by-item")
                        .hide();
                    }
                  }
                });
              }
            });
        }
      });
    }

    setTimeout(function () {
      $(document).ready(function () {
        showSelectedRateDiv();
      });

      var curr_lang = $("input#LocaleSelector").val();

      $(
        "#CollectionProductGrid .boost-pfs-filter-options-wrapper .boost-pfs-filter-option"
      ).each(function (i, li) {
        if (curr_lang == "de") {
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-chirurgie-dermatologique"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-dermochirurgia"
          ).hide();

          $(".boost-pfs-filter-option.boost-pfs-filter-option-corps").hide();
          $(".boost-pfs-filter-option.boost-pfs-filter-option-corpo").hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-protection-laser"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-protezione-laser"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-viso-collo"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-visage-cou"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-peli-superflui-pigmentazione-vascolarizzazione"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-pilosite-pigmentation-vascularisation"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-pigmento-da-tatuaggio"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-pigment-de-tatouage"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-terapia-uv"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-traitement-uv"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-gastro-champ-d-x27-application"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-area-di-applicazione"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-surgical-champ-d-x27-application"
          ).hide();
        }

        if (curr_lang == "fr") {
          //       $('.boost-pfs-filter-option-marke .boost-pfs-filter-button span.boost-pfs-filter-option-title-text').text('MARQUE');

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-dermatochirurgie"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-dermochirurgia"
          ).hide();

          $(".boost-pfs-filter-option.boost-pfs-filter-option-korper").hide();
          $(".boost-pfs-filter-option.boost-pfs-filter-option-corpo").hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-protezione-laser"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-laserschutz"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-viso-collo"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-gesicht-nacken"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-peli-superflui-pigmentazione-vascolarizzazione"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-haare-pigment-vaskular"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-pigmento-da-tatuaggio"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-tatowierung-pigment"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-terapia-uv"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-uv-therapie"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-gastro-anwendungsbereich"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-area-di-applicazione"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-surgical-anwendungsbereich"
          ).hide();
        }

        if (curr_lang == "it") {
          //       $('.boost-pfs-filter-option-marke .boost-pfs-filter-button span.boost-pfs-filter-option-title-text').text('MARCA');

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-dermatochirurgie"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-chirurgie-dermatologique"
          ).hide();

          $(".boost-pfs-filter-option.boost-pfs-filter-option-korper").hide();
          $(".boost-pfs-filter-option.boost-pfs-filter-option-corps").hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-protection-laser"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-laserschutz"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-visage-cou"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-gesicht-nacken"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-pilosite-pigmentation-vascularisation"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-haare-pigment-vaskular"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-pigment-de-tatouage"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-tatowierung-pigment"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-traitement-uv"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-uv-therapie"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-gastro-anwendungsbereich"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-gastro-champ-d-x27-application"
          ).hide();

          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-surgical-anwendungsbereich"
          ).hide();
          $(
            ".boost-pfs-filter-option.boost-pfs-filter-option-surgical-champ-d-x27-application"
          ).hide();
        }
      });
    }, 2000);

    $(".boost-pfs-filter-option-content-inner").on("scroll", function (e) {
      e.stopPropagation();
      setTimeout(function () {
        for (var i = 1; i <= 5; i++) {
          var n = 6;
          $(
            ".boost-pfs-filter-option-attributes ul.boost-pfs-filter-option-item-list-single-list li.boost-pfs-filter-option-item"
          ).each(function (e) {
            if ($(this).siblings(".wrapperDiv").length == 0) {
              var name = $(this).find(".boost-pfs-filter-option-value").text();
              var thats = $(this);
              var filter_title = $(this)
                .parents(".boost-pfs-filter-option-list")
                .find(
                  ".boost-pfs-filter-option-title-text:not(.boost-pfs-filter-option-title-count)"
                )
                .text();

              var filter_title_new = filter_title.replace(1, "");
              filter_title_new = filter_title_new.replace(2, "");

              if (name.indexOf("-") > -1) {
                //               thats.parents('.mainwrapperDiv').hide();
              } else {
                var data_index = name + "-" + (n - i);
              }

              $(this).after(
                '<div class="star" data-index="attribute_' +
                  lang +
                  "_" +
                  filter_title_new +
                  "_" +
                  data_index +
                  '"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 55.867 55.867" style="enable-background:new 0 0 55.867 55.867;" xml:space="preserve"><path d="M55.818,21.578c-0.118-0.362-0.431-0.626-0.808-0.681L36.92,18.268L28.83,1.876c-0.168-0.342-0.516-0.558-0.896-0.558 s-0.729,0.216-0.896,0.558l-8.091,16.393l-18.09,2.629c-0.377,0.055-0.689,0.318-0.808,0.681c-0.117,0.361-0.02,0.759,0.253,1.024 l13.091,12.76l-3.091,18.018c-0.064,0.375,0.09,0.754,0.397,0.978c0.309,0.226,0.718,0.255,1.053,0.076l16.182-8.506l16.18,8.506 c0.146,0.077,0.307,0.115,0.466,0.115c0.207,0,0.413-0.064,0.588-0.191c0.308-0.224,0.462-0.603,0.397-0.978l-3.09-18.017 l13.091-12.761C55.838,22.336,55.936,21.939,55.818,21.578z"/></svg></div>'
              );

              // var name = $(this).find('.boost-pfs-filter-option-value').text();
              // var thats = $(this);

              // if(name.indexOf('-') > -1){
              //   //               thats.parents('.mainwrapperDiv').hide();

              // }else{

              //   var data_index = name+"-"+(n-i);
              // }
              // $(this).after('<div class="star" data-index="attribute_'+data_index+'"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 55.867 55.867" style="enable-background:new 0 0 55.867 55.867;" xml:space="preserve"><path d="M55.818,21.578c-0.118-0.362-0.431-0.626-0.808-0.681L36.92,18.268L28.83,1.876c-0.168-0.342-0.516-0.558-0.896-0.558 s-0.729,0.216-0.896,0.558l-8.091,16.393l-18.09,2.629c-0.377,0.055-0.689,0.318-0.808,0.681c-0.117,0.361-0.02,0.759,0.253,1.024 l13.091,12.76l-3.091,18.018c-0.064,0.375,0.09,0.754,0.397,0.978c0.309,0.226,0.718,0.255,1.053,0.076l16.182-8.506l16.18,8.506 c0.146,0.077,0.307,0.115,0.466,0.115c0.207,0,0.413-0.064,0.588-0.191c0.308-0.224,0.462-0.603,0.397-0.978l-3.09-18.017 l13.091-12.761C55.838,22.336,55.936,21.939,55.818,21.578z"/></svg></div>');
            } else {
            }
          });

          $(
            "#boost-pfs-filter-tree-pf-t-gesicht-nacken li.boost-pfs-filter-option-item, #boost-pfs-filter-tree-pf-t-dermatochirurgie li.boost-pfs-filter-option-item, #boost-pfs-filter-tree-pf-t-korper li.boost-pfs-filter-option-item,#boost-pfs-filter-tree-pf-t-schlatte-hour li.boost-pfs-filter-option-item,#boost-pfs-filter-tree-pf-t-haare-pigment-vaskular li.boost-pfs-filter-option-item,#boost-pfs-filter-tree-pf-t-tatowierung-pigment li.boost-pfs-filter-option-item, #boost-pfs-filter-tree-pf-t-uv-therapie li.boost-pfs-filter-option-item, #boost-pfs-filter-tree-pf-t-laserschutz li.boost-pfs-filter-option-item, #boost-pfs-filter-tree-pf-t-tattoo-pigment li.boost-pfs-filter-option-item, #boost-pfs-filter-tree-pf-t-haare-pigment-vaskular li.boost-pfs-filter-option-item"
          ).each(function (e) {
            if ($(this).siblings(".wrapperDiv").length == 0) {
              var name = $(this).find(".boost-pfs-filter-option-value").text();
              var thats = $(this);
              var filter_title = $(this)
                .parents(".boost-pfs-filter-option-list")
                .find(
                  ".boost-pfs-filter-option-title-text:not(.boost-pfs-filter-option-title-count)"
                )
                .text();

              var filter_title_new = filter_title.replace(1, "");
              filter_title_new = filter_title_new.replace(2, "");

              if (name.indexOf("-") > -1) {
                //               thats.parents('.mainwrapperDiv').hide();
              } else {
                var data_index = name + "-" + (n - i);
              }
              $(this).after(
                '<div class="star" data-index="attribute_' +
                  lang +
                  "_" +
                  filter_title_new +
                  "_" +
                  data_index +
                  '"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 55.867 55.867" style="enable-background:new 0 0 55.867 55.867;" xml:space="preserve"><path d="M55.818,21.578c-0.118-0.362-0.431-0.626-0.808-0.681L36.92,18.268L28.83,1.876c-0.168-0.342-0.516-0.558-0.896-0.558 s-0.729,0.216-0.896,0.558l-8.091,16.393l-18.09,2.629c-0.377,0.055-0.689,0.318-0.808,0.681c-0.117,0.361-0.02,0.759,0.253,1.024 l13.091,12.76l-3.091,18.018c-0.064,0.375,0.09,0.754,0.397,0.978c0.309,0.226,0.718,0.255,1.053,0.076l16.182-8.506l16.18,8.506 c0.146,0.077,0.307,0.115,0.466,0.115c0.207,0,0.413-0.064,0.588-0.191c0.308-0.224,0.462-0.603,0.397-0.978l-3.09-18.017 l13.091-12.761C55.838,22.336,55.936,21.939,55.818,21.578z"/></svg></div>'
              );
            } else {
            }
          });
        }

        $(".boost-pfs-filter-option-label").click(function () {
          $(".wrapperDiv").hide();
          $(this).find(".wrapperDiv").show();
        });
        //     $('.boost-pfs-filter-option-item.boost-pfs-filter-option-label').each(function(){})
        if (
          $(
            ".boost-pfs-filter-option-item.boost-pfs-filter-option-label"
          ).hasClass("selected")
        ) {
          $(
            ".boost-pfs-filter-option-item.boost-pfs-filter-option-label.selected"
          )
            .parents(".mainwrapperDiv")
            .find(".wrapperDiv")
            .show();
        } else {
          $(".wrapperDiv").hide();
        }

        $(".boost-pfs-filter-option-item  + .star").each(function () {
          $(this)
            .nextUntil(".boost-pfs-filter-option-item")
            .addBack()
            .wrapAll("<div class='wrapperDiv' />");
        });

        $(".boost-pfs-filter-option-item").each(function () {
          if ($(this).parents(".mainwrapperDiv").length == 0) {
            $(this)
              .nextUntil(".boost-pfs-filter-option-item")
              .addBack()
              .wrapAll("<div class='mainwrapperDiv' />");
          }
        });

        $(".boost-pfs-filter-option-value").each(function () {
          var val = $(this).text();
          var $this = $(this);
          if (val.indexOf("-") > -1) {
            if(val != 'ELLA-CS, S.r.o.') {
              $this.parents(".mainwrapperDiv").hide();
            }            
          }
        });
      });
      showSelectedRateDiv();
      $(".star").click(function (e) {
        e.preventDefault();
        $(".star").css("pointer-events", "none");
        var index = $(this).attr("data-index");
        //index = index.toLowerCase().replace(/ /g,'-');
        $(this).addClass("active");
        $(this).nextAll().removeClass("active");
        $(this).prevAll().addClass("active");

        var locations = location.pathname;
        var locations_all = location.href;
        var location_search = location.search.split("=");
        var nacken = getUrlParameter("pf_t_gesicht_nacken");

        var filter_param = $(this)
          .parents(".boost-pfs-filter-option-list")
          .find(".boost-pfs-filter-option-content")
          .attr("id");
        var filter_param_ori = filter_param.replace(
          "boost-pfs-filter-tree-",
          ""
        );
        var filter_param_new = filter_param.replace(
          "boost-pfs-filter-tree-",
          ""
        );
        var spaceCount = filter_param_new.split("-").length - 1;

        for (var i = 0; i < spaceCount; i++) {
          filter_param_new = filter_param_new.replace("-", "_");
        }

        var url = new window.URL(document.location); // fx. http://host.com/endpoint?abc=123

        if (window.location.href.indexOf(filter_param_new) > -1) {
          url.searchParams.set(filter_param_new, index);

          var index_count = index.slice(-1);
          var index_original_count = index_count;

          if (index_count < 5) {
            while (index_count <= 5) {
              if (index_original_count != index_count) {
                url.searchParams.append(
                  filter_param_new,
                  index.slice(0, -1) + index_count
                );
              }
              index_count++;
            }
          }

          var new_url = url.toString();

          window.location = new_url;

          /*$.ajax({
              url: new_url,
              type: 'GET',
              success: function(res) {

                setTimeout(function(){
                  $('#main-collection-product-grid').html('');
                  $('#main-collection-product-grid').html($(res).find("#main-collection-product-grid").html());
                },500);
                setTimeout(function(){

                  $('.star').css("pointer-events", "auto");
                }, 1000);
              }

            });*/
        } else {
          $.ajax({
            url: "https://lasermedch.myshopify.com" + locations + "/" + index,
            type: "GET",
            success: function (res) {
              setTimeout(function () {
                $("#main-collection-product-grid").html("");
                $("#main-collection-product-grid").html(
                  $(res).find("#main-collection-product-grid").html()
                );
              }, 500);
              setTimeout(function () {
                $(".star").css("pointer-events", "auto");
              }, 1000);
            },
          });
        }
      });
    });
  };

  /************************** END BUILD TOOLBAR **************************/

  // Integrate with Bold Custom Price
  function reload_js(src) {
    // jQ('script[src="' + src + '"]').remove();
    // jQ("<script>").attr("src", src).appendTo("head");
  }
})();
